import { formatDate } from 'lib/format-date';
import {DrupalMedia, DrupalNode, DrupalParagraph} from "next-drupal";
import {Hero} from "../../organisms/hero";
import {useRouter} from "next/router";
import dynamic from "next/dynamic";
import {ProductTypeTaxonomyTerm} from "@/types/hygiena-types";
import {getParagraphSections} from "@/lib/get-paragraph-sections";
const RenderSections = dynamic(() => import("@/components/templates/sections/section-regions").then(mod => mod.RenderSections));

const ContentArticleBody = dynamic(() => import("../../templates/nodes/content/content--article").then((mod) => mod.ContentArticleBody));
const ContentArticleLower = dynamic(() => import("../../templates/nodes/content/content--article").then((mod) => mod.ContentArticleLower));

export function NodeArticle({ node, imageField, date = "", categoryTerm = null, additionalContent, ...props }: {
  node: DrupalNode,
  imageField?: DrupalMedia,
  date: string,
  categoryTerm?: ProductTypeTaxonomyTerm|null,
  additionalContent: any,
}) {
  const {locale} = useRouter();
  const {sections, sectionMap} = getParagraphSections(node?.field_article_layout_components);

  return (
    <>
      <article {...props} className={"article-full"}>
        <Hero image={imageField}>
          <div className="bg-hygienaLight/60 backdrop-blur-md w-full drop-shadow-sm py-8 px-4 md:px-16 md:py-20 rounded-sm text-black flex flex-col justify-center items-center text-center">
            {categoryTerm?.name && (
              <p className="m-0 text-xl font-bold text-primary">
                {categoryTerm.name}
              </p>
            )}
            <h1 className="py-6 font-medium">{node.title}</h1>
            <p className="text-gray-600 text-xl">
              {date && <span>{formatDate(date, locale)}</span>}
            </p>
          </div>
        </Hero>
        <ContentArticleBody node={node}/>
        {sections?.length ? (
          <RenderSections sections={sections} sectionMap={sectionMap} noPad={true} />
        ): <></>}
      </article>
      <ContentArticleLower node={node} additionalContent={additionalContent}/>
    </>
  );
}